import TextField from 'components/AppForm/TextField';
import React, { useEffect } from 'react';
import { X } from 'react-feather';
import { Controller, useForm } from 'react-hook-form';
import { ModalBody } from 'reactstrap';
import { Footer } from '../Footer';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useMediaScreen } from 'hooks/useMediaScreen';

export type Props = {
  onOk?: (data?: any) => void;
  onCancel: () => void;
  defaultValue?: string;
  labelOK: string;
  inputLabel?: string;
  inputPlaceHolder?: string;
  headerTitle: string;
  isLoading?: boolean;
  titleIcon?: JSX.Element;
  errorLabel?: string;
};

export const TitleForm = ({
  onOk,
  onCancel,
  defaultValue,
  labelOK,
  headerTitle,
  inputPlaceHolder,
  inputLabel,
  isLoading,
  titleIcon = null,
  errorLabel,
}: Props) => {
  const TitleFormSchema = yup.object().shape({
    title: yup
      .string()
      .trim()
      .required(`${inputLabel || errorLabel} is required.`),
  });
  const { isMdDown } = useMediaScreen();
  const {
    control,
    formState: { errors },
    setFocus,
    handleSubmit,
  } = useForm({
    defaultValues: {
      title: defaultValue,
    },
    resolver: yupResolver(TitleFormSchema as any),
    reValidateMode: 'onChange',
  });

  useEffect(() => {
    if (!isMdDown) {
      setFocus('title', { shouldSelect: true });
    }
  }, [setFocus, isMdDown]);

  return (
    <div className="p-3 d-flex flex-column create-content-modal modal-wrapper">
      <ModalBody className="gap-3 mb-3 d-flex flex-column">
        <div className="d-flex justify-content-between align-items-start w-100">
          <div className="gap-4 d-flex flex-column">
            {titleIcon && (
              <div className="p-2 d-flex align-items-center justify-content-center rounded-circle h-48px w-48px bg-primary-50">
                {titleIcon}
              </div>
            )}

            <div className="gray-900 fw-semibold font-size-18">{headerTitle}</div>
          </div>
          <X
            onClick={() => onCancel?.()}
            className="cursor-pointer close-icon gray-400 d-block"
            size={24}
            data-cy="close-icon"
          />
        </div>

        <div className="mt-2 form-group font-size-12">
          <Controller
            name="title"
            control={control}
            render={({ field, formState }) => {
              return (
                <TextField
                  value={field.value}
                  placeholder={inputPlaceHolder}
                  error={formState.errors?.title}
                  label={inputLabel}
                  onChange={event => field.onChange(event.target.value)}
                  dataCy="title"
                  ref={field.ref}
                />
              );
            }}
          />

          {errors?.title?.message && (
            <p
              className="feedback-invalid"
              data-cy="invalid-name"
            >
              {errors?.title?.message}
            </p>
          )}
        </div>
      </ModalBody>

      <Footer
        labelCancel="Cancel"
        labelOK={labelOK}
        onOK={handleSubmit(onOk)}
        onCancel={() => onCancel?.()}
        isLoading={isLoading}
      />
    </div>
  );
};
